import { financingTypes } from '../../data/filterOptions';
import { FilterSection } from './FilterSection';
import { useTranslation } from 'react-i18next';

interface FinancingFilterProps {
  selectedTypes: string[];
  onChange: (value: string) => void;
}

export function FinancingFilter({ selectedTypes, onChange }: FinancingFilterProps) {
	const { t } = useTranslation();
  return (
    <FilterSection title={t('store.filters.financingType')}>
      {financingTypes.map((type) => (
        <div key={type.id} className="flex items-center">
          <input
            id={`financing-${type.id}`}
            type="checkbox"
            checked={selectedTypes.includes(type.id)}
            onChange={() => onChange(type.id)}
            className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-indigo-500"
          />
          <label
            htmlFor={`financing-${type.id}`}
            className="ml-3 text-sm text-gray-600"
          >
			{t(`store.filterOptions.financing.${type.id}`, { defaultValue: type.label })}
          </label>
        </div>
      ))}
    </FilterSection>
  );
}